import React from 'react';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Check, X, Pencil, RefreshCw } from 'lucide-react';

// Mock data for a single QA pair
const mockQaPair = {
  id: 'qa-1',
  question: 'What were the total revenues for Q3 2023?',
  answer: 'The total revenues for Q3 2023 were $15.2 million, a 12% increase year-over-year.',
  context: '...The financial report for the third quarter of 2023 shows strong performance across all sectors. The total revenues for Q3 2023 were $15.2 million, a 12% increase year-over-year. This growth was primarily driven by the successful launch of the new product line in the APAC region...',
  queueCount: 42,
};

const ValidationPage: React.FC = () => {
  const [question, setQuestion] = React.useState(mockQaPair.question);
  const [answer, setAnswer] = React.useState(mockQaPair.answer);
  const [isEditing, setIsEditing] = React.useState(false);

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleSaveChanges = () => {
    setIsEditing(false);
    // In a real app, you'd submit the changes here
    console.log('Changes saved:', { question, answer });
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold">QA Pair Validation</h1>
          <p className="text-muted-foreground">
            You have <span className="font-semibold text-primary">{mockQaPair.queueCount}</span> pairs left to validate.
          </p>
        </div>
        <Button variant="outline">
          <RefreshCw className="mr-2 h-4 w-4" />
          Fetch Next QA Pair
        </Button>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Review Generated QA</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="question">Question</Label>
            <Input
              id="question"
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              readOnly={!isEditing}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="answer">Answer</Label>
            <Textarea
              id="answer"
              value={answer}
              onChange={(e) => setAnswer(e.target.value)}
              readOnly={!isEditing}
              rows={5}
            />
          </div>
          <div className="space-y-2">
            <Label>Source Context</Label>
            <div className="p-4 border rounded-md bg-muted text-sm text-muted-foreground">
              {mockQaPair.context}
            </div>
          </div>
        </CardContent>
        <CardFooter className="flex justify-end space-x-2">
          {!isEditing ? (
            <>
              <Button variant="destructive">
                <X className="mr-2 h-4 w-4" /> Reject
              </Button>
              <Button variant="outline" onClick={handleEdit}>
                <Pencil className="mr-2 h-4 w-4" /> Edit
              </Button>
              <Button>
                <Check className="mr-2 h-4 w-4" /> Approve
              </Button>
            </>
          ) : (
            <Button onClick={handleSaveChanges}>
              <Check className="mr-2 h-4 w-4" /> Save Changes & Approve
            </Button>
          )}
        </CardFooter>
      </Card>
    </div>
  );
};

export default ValidationPage;